export enum ECounterSource {
    CUSTOM = "custom",
    REDUCE = "reduce",
    INCREASE = "increase",
}